import React, { useContext, useState } from "react";
import { Link } from "gatsby";
import { AuthContext } from "../../contexts/AuthContext";
import getLoginType from "../../utils/loginConfig";
import efpaConfig from "../../utils/efpaConfig";
import PodcastIcon from "../../components/Podcasticon";
import Finectlogo from "../../components/Finectlogo";
import YoutubeLogo from "../../components/YoutubeLogo";
import TwitterLogo from "../../components/TwitterLogo";
import VimeoLogo from "../../components/VimeoLogo";
import LinkedinLogo from "../../components/LinkedinLogo";
import InstagramLogo from "../../components/InstagramLogo";
import FacebookLogo from "../Facebooklogo";
import Whatsappicon from "../Whatsappicon";
// import finectLogo from '../../images/icon-finect.jpg';

export default function HeaderMenu() {
  const [loginType] = useState(getLoginType());
  const { userInfo, logout, isAuth } = useContext(AuthContext);
  return (
    <div className="Header">
      <div className="Header-container">
        <img
          className="Header-logo"
          src={efpaConfig.GATSBY_LOGO_PATH}
          alt="Logo"
        />
        <div className="Header-floatr">
          <div className="Header-wrapperIcons">
            <ul className="Header-social">
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://whatsapp.com/channel/0029VadiIhA4CrfkiMEHPi0b"
                >
                  <Whatsappicon color="#112149" className={"fa-icon"}/>
                </a>
              </li>
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://open.spotify.com/show/09UislSj5XnNvHsWvonRlT"
                >
                  <PodcastIcon color="#112149" className={"fa-icon"}/>
                </a>
              </li>
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://twitter.com/efpa_es"
                >
                  <TwitterLogo color="#112149" className={"fa-icon"}/>{" "}
                </a>
              </li>
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/efpa.espana/"
                >
                  <FacebookLogo color="#112149" className={"fa-icon"}/>{" "}
                </a>
              </li>
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/efpa_es/"
                >
                  <InstagramLogo color="#112149" className={"fa-icon"}/>{" "}
                </a>
              </li>
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.finect.com/grupos/efpa_espana/conoce_a_efpa"
                >
                  <Finectlogo color="#112149" className={"fa-icon"}/>
                </a>
              </li>
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://vimeo.com/efpaespana"
                >
                  <VimeoLogo color="#112149" className={"fa-icon"}/>{" "}
                </a>
              </li>
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/user/efpaes"
                >
                  <YoutubeLogo color="#112149" className={"fa-icon"}/>{" "}
                </a>
              </li>
              <li className="Header-list">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/company/efpa-spain/"
                >
                  <LinkedinLogo color="#112149" className={"fa-icon"}/>{" "}
                </a>
              </li>
            </ul>
          </div>
          {isAuth && (
              <div className="Header-acceso">
                <div className="Header-accessWrap">
                  <span>{userInfo.full_name}</span>
                  <Link
                      className="Header-acceso-link test"
                      to={loginType.home}
                      onClick={logout}
                  >
                  Salir
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
